import Component from 'components/pages/Earn/Earn.qmee';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('earn');
export default buildPage(Component, {
  requiresAuthentication: true,
  metaData: {
    title: 'Earn',
    description: 'Earn',
  },
});
